<template>
  <transition name="page-transition">
    <div
      class="hotel-page"
      :class="{
        loading: loading,
        'loading-more-offers': loadingNextOffers,
        'loading-filters': loadingFilters,
      }"
    >
      <result-hero></result-hero>
      <result-area
        :loading-offers="loading"
        :loading-filters="loadingFilters"
        :error-code="offerErrorCode"
        :filter-error="filterError"
        @loadmore="loadNextOffers"
      ></result-area>
    </div>
  </transition>
</template>

<script>
import ResultHero from "../components/result-hero.vue";
import ResultArea from "../components/result-area.vue";
import Moment from "moment";
import _ from "underscore";

export default {
  mounted() {
    this.updateQueryData();
    this.updateDestination();
    this.loadFilters();
    this.$nextTick(() => {
        this.loadOffers();
    });
  },
  beforeDestroy() {
    this.$store.commit('offers', [ ]);
  },
  data() {
    return {
      loading: false,
      loadingNextOffers: false,
      loadingFilters: false,
      offerErrorCode: null,
      filterError: false,
      queryTimer: null,
      currentLodingQueryString: ''
    };
  },
  watch: {
    "$route.query"(newQuery, oldQuery) {
      if (this.queryTimer) {
        clearTimeout(this.queryTimer);
      }

      this.queryTimer = setTimeout(() => {
        this.updateQueryData();
        this.loadOffers();
      }, 500);
    },
    "$route.query.destinationId"() {
      this.updateDestination();
    },
    travelSearchQuery(newQuery, oldQuery) {
      if (!_.isEqual(newQuery, oldQuery)) {
        this.loadFilters();
      }
    },
  },
  computed: {
    travelSearchQuery() {
      return this.$store.getters.travelSearchQuery;
    },
  },
  methods: {
    updateQueryData() {
      this.$store.commit("travelQuery", this.getQuery());
    },
    loadFilters() {
      if (this.loadingFilters) return;

      this.loadingFilters = true;
      this.filterError = false;
      this.$store
        .dispatch("loadFilters", this.getQuery())
        .then(() => {
          this.loadingFilters = false;
        })
        .catch(() => {
          this.loadingFilters = false;
          this.filterError = true;
        });
    },
    getQuery() {
      let query = Object.assign(
        {},
        {
          fromDate: Moment()
            .set({ hour: 0, minute: 0, second: 0 })
            .add(1, "month")
            .format("YYYY-MM-DD"),
          toDate: Moment()
            .set({ hour: 0, minute: 0, second: 0 })
            .add(1, "month")
            .add(7, "days")
            .format("YYYY-MM-DD"),
          departureAirport: "HAM",
          adults: 2,
          childrenCount: 0,
          children: null,
          flexibleStartDays: 0,
          flexibleEndDays: 0,
        },
        this.$route.query
      );

      if (typeof query.keywords === "string") {
        try {
          query.keywords = JSON.parse(query.keywords);
        } catch (e) {
          query.keywords = [];
        }
      }

      if (typeof query.children === "string") {
        try {
          query.children = JSON.parse(query.children);
        } catch (e) {
          query.children = null;
        }
      }

      if (typeof query.tourOperator === "string") {
        try {
          query.tourOperator = JSON.parse(query.tourOperator);
        } catch (e) {
          query.tourOperator = null;
        }
      }

      if (typeof query.roomTypeCode === "string") {
        query.roomTypeCode = [query.roomTypeCode];
      }

      if (typeof query.boardTypeCode === "string") {
        query.boardTypeCode = [query.boardTypeCode];
      }

      if (typeof query.roomLocatedCode === "string") {
        query.roomLocatedCode = [query.roomLocatedCode];
      }

      if (typeof query.adults === "string") {
        query.adults = parseInt(query.adults);
      }

      if (typeof query.childrenCount === "string") {
        query.childrenCount = parseInt(query.childrenCount);
      }

      if (typeof query.flexibleStartDays === "string") {
        query.flexibleStartDays = parseInt(query.flexibleStartDays);
      }

      if (typeof query.flexibleEndDays === "string") {
        query.flexibleEndDays = parseInt(query.flexibleEndDays);
      }

      return query;
    },
    loadOffers() {
      this.loading = true;
      this.offerErrorCode = null;
      
      let query = this.getQuery();
      let queryString = JSON.stringify(query);
      if(queryString == this.currentLodingQueryString) {
        return;
      }

      this.currentLodingQueryString = queryString;

      this.$store
        .dispatch("getOffers", query)
        .then(() => {
          this.loading = false;
          this.currentLodingQueryString = '';
        })
        .catch((error) => {
          this.loading = false;
          if (error && error.response) {
            this.offerErrorCode = error.response.status;
          } else {
            this.offerErrorCode = 0;
          }
        });
    },
    loadNextOffers() {
      if (this.loadingNextOffers) return;

      this.loadingNextOffers = true;
      this.$store
        .dispatch("getNextOffers", this.getQuery())
        .then(() => {
          this.loadingNextOffers = false;
        })
        .catch((error) => {
          this.loadingNextOffers = false;
        });
    },
    updateDestination() {
      if (this.$route.query.destinationId) {
        this.$store.dispatch("getDestination", this.getQuery());
      }
    },
  },
  components: {
    ResultHero,
    ResultArea,
  },
};
</script>
